// extracted by mini-css-extract-plugin
export default {"genericCard":"Ip-z","inline":"Jp-z","mastercard":"Kp-z","discover":"Lp-z","visa":"Mp-z","amex":"Np-z","active":"Op-z"};